<template>
    <div :key="reRenderKey">
        <div id="pixi-house" ref="pixiHouse" />
        <ShareNetwork            
            network="facebook"
            url="rfclab-phaser-game.appspot.com/"
            title="ชั่งผักรักเลย"
            description="ลองเล่นเกมนี้ เพื่อทายปริมาณผักผลไม้ที่ทานในแต่ละวันกัน"
            quote=""
            hashtags="ชั่งผักรักเลย,สสส"
        >
            <div ref="shareNetworkFB" />
        </ShareNetwork>        
        <ShareNetwork
            network="twitter"
            url="rfclab-phaser-game.appspot.com/"
            title="ชั่งผักรักเลย"
            hashtags="ชั่งผักรักเลย,สสส"
        >
            <div ref="shareNetworkTwitter" />
        </ShareNetwork>
        <ShareNetwork
            network="line"
            url="rfclab-phaser-game.appspot.com/"
            title="ชั่งผักรักเลย"
            description="ลองเล่นเกมนี้ เพื่อทายปริมาณผักผลไม้ที่ทานในแต่ละวันกัน"
        >
            <div ref="shareNetworkLine" />
        </ShareNetwork>

        <!-- <audio loop preload="auto" :src="require( '@/game/assets/carefree-by-kevin-macleod-from-filmmusic-io.mp3' )" /> -->
    </div>
</template>

<script>

import * as PIXI from 'pixi.js'
const TextInput = require('pixi-text-input') //https://github.com/Mwni/PIXI.TextInput

import LoaderManager from './managers/LoaderManager'
import Util from './managers/PIXIUtil'

import EventDispatcher from '@/game/scenes/components/EventDispatcher'

// import {mapGetters, mapMutations, mapActions} from 'vuex';
// import * as types from '@/store/types';
// import EventBus from '@/eventBus'
// import SomeComponent from '@/components/SomeComponent.vue'

// import moment from 'moment';
import axios from 'axios'
const _ = require('lodash')
import * as config from '@/store/config'

const TILING_SPEED = 0.5
const GENDER_TEXTURE_MAP = {
    N: 'imgP4Player1',
    M: 'imgP4Player2',
    F: 'imgP4Player3',
}

const getInitialGameState = function() {
    let gameState = {
        selectedVeggie: -1,
        cart: {},
        min: 0,
        second: 30,
        interval: null,
    }
    for(let i = 0; i < 40; ++i) {
        gameState.cart[i] = 0
    }
    return gameState
}

const getVeggiePositionList = function(type) {
    let positions = []
    const POOL_AMOUNT = 10
    const POOL_HALF_AMOUNT = 5
    if( type == 0 ) {
        for( let i = 0; i < POOL_AMOUNT; ++i ) {
            positions.push({
                x: 380
                + (i < 5 ? 0 : 370),
                y: 270 
                + (
                    i
                    + (i < POOL_HALF_AMOUNT ? 0 : -5 ) 
                )
                * 110,
            })
        }
    }
    if( type == 1 ) {
        for( let i = 0; i < POOL_AMOUNT; ++i ) {
            positions.push({
                x: 250
                + (i < 5 ? 0 : 450),
                y: 130 
                + (
                    i
                    + (i < POOL_HALF_AMOUNT ? 0 : -5 ) 
                )
                * 110,
            })
        }
    }
    return positions;
}

const VEGGIE_WEIGHT = [
  [1,50,"ต้น" ],
  [2,5,"ต้น" ],
  [3,4,"ใบ" ],
  [4,15,"ต้น" ],
  [5,15,"ใบ" ],
  [6,30,"ใบ" ],
  [7,10,"ใบ" ],
  [8,35,"ชิ้น" ],
  [9,20,"กำมือ" ],
  [10,45,"ผลกลาง" ],
  [11,80,"ผลกลาง" ],
  [12,14,"ชิ้น" ],
  [13,75,"ชิ้น" ],
  [14,72,"ผล" ],
  [15,15,"ฝัก" ],
  [16,2,"ฝัก" ],
  [17,17,"ฝัก" ],
  [18,115,"ชิ้น" ],
  [19,10,"ชิ้น" ],
  [20,15,"ชิ้น" ],
  [21,25,"ชิ้น" ],
  [22,30,"ชิ้น" ],
  [23,22,"ชิ้น" ],
  [24,87,"ผล" ],
  [25,10,"ผล" ],
  [26,30,"ผล" ],
  [27,122,"ผล" ],
  [28,92,"กลีบ" ],
  [29,102,"ผล" ],
  [30,53,"ผล" ],
  [31,106,"ผล" ],
  [32,150,"ผล" ],
  [33,76,"ผล" ],
  [34,264,"ผล" ],
  [35,170,"ชิ้น" ],
  [36,43,"ชิ้น" ],
  [37,101,"ชิ้น" ],
  [38,15,"เม็ดกลาง" ],
  [39,9,"ผล" ],
  [40,18,"ผล" ]
]

const VERIFY_WEIGHT_THRESHOLD = {
    KID: 350,
    ADULT: 400,
}

const START_FRUIT_INDEX = 26

const VEGGIE_FRUIT_RATIO = 1.5

const ADULT_AGE = 15

export default { 
    props: [
        // "items"
    ],
    data() {
        return {
            reRenderKey: 0,
            app: new PIXI.Application({
                width: 1280, 
                height: 960,
            }),
            // app: new PIXI.Application({ resizeTo: window }),
            renderer: null,
            width: 1280,
            height: 960,
            ratio: 1,
            iter: 0,
            textureMap: null,
            audioPlayed: false,
            pageState: {
                curr: "none",
                prev: "none",
            },
            popupState: "",
            gameState: getInitialGameState(),
            gameData: {
                weight: 0,
                enough: false,
                ratio: false,
                name: "",
                age: 15,
                gender: "N",
            },
            socialSharingData: {
                url: "rfclab-phaser-game.appspot.com/",
                title: "ชั่งผักรักเลย",
                description: "ลองเล่นเกมนี้ เพื่อทายปริมาณผักผลไม้ที่ทานในแต่ละวันกัน",
                hashTags: "ชั่งผักรักเลย,สสส",
            },
            hierarchy: {
                none: {},
                shared: {},
                title: {},
                howToPlay: {},
                characterCreator: {},
                characterProfile: {},
                gameplay: {},
                summary: {},
                result: {},
            },
            popups: {
                timesup: {},
                cart: {},
                veggieInfo: {},
                veggieReach: {},
            },
            veggiePool: [],
            eventDispatcher: EventDispatcher.create(),
            genderDropdownState: {
                expand: false,
                value: 'N',
            }
        };
    },
    mounted: function () {
        const self = this
        const app = self.app

        window.addEventListener('click', function (e) {
            if( !self.audioPlayed ) {
                var audio = new Audio(require( "@/game/assets/carefree-by-kevin-macleod-from-filmmusic-io-compressed.mp3" ))
                audio.play()
                audio.loop = true
                self.audioPlayed = true
            }
        })
        

        self.ratio = self.width / self.height

        // this.$el.appendChild(app.view)
        this.$refs.pixiHouse.appendChild(app.view)

        // self.stage = new PIXI.Stage(0x333333, true)
        // self.renderer = PIXI.autoDetectRenderer(self.width, self.height)
        // self.$el.appendChild(self.renderer.view)

        self.renderer = app.renderer

        LoaderManager.load( PIXI, app, function(textureMap, resources) {

            self.textureMap = textureMap
            
            const addSprite = function(textureName, x, y, scale) {
                const sp = new PIXI.Sprite( textureMap[ textureName ].texture )
                sp.x = app.renderer.width * x
                sp.y = app.renderer.height * y
                sp.anchor.x = 0.5
                sp.anchor.y = 0.5
                sp.scale.set(scale)
                app.stage.addChild(sp)
                return sp
            }

            const tilingSprite = new PIXI.TilingSprite(
                textureMap['imgBgGreen'].texture,
                self.width,
                self.height,
            )
            app.stage.addChild(tilingSprite)
            tilingSprite.tileScale.x = 1
            tilingSprite.tileScale.y = 1
            tilingSprite.tilePosition.x += 40
            self.hierarchy.shared.tilingSprite = tilingSprite

            self.eventDispatcher.listenToEvent(
                "pageChanged",
                function(payload) {
                    if(payload.curr == "title")
                        self.setBackgroundTexture( "imgBgGreen" )
                    if(payload.curr == "howToPlay")
                        self.setBackgroundTexture( "imgBgOrange" )
                    if(payload.curr == "characterCreator")
                        self.setBackgroundTexture( "imgBgYellow" )
                    if(payload.curr == "characterProfile")
                        self.setBackgroundTexture( "imgBgYellow" )
                    if(payload.curr == "gameplay")
                        self.setBackgroundTexture( "imgBgOrange" )
                    if(payload.curr == "summary")
                        self.setBackgroundTexture( "imgBgGreen" )
                    if(payload.curr == "result")
                        self.setBackgroundTexture( "imgBgOrange" )
                }
            )
            
            //------ Title Page ------//
            {
                const title = new PIXI.Sprite( textureMap['imgP1Title'].texture )
                title.x = app.renderer.width * 0.5
                title.y = app.renderer.height * 0.45
                title.anchor.x = 0.5
                title.anchor.y = 0.5
                app.stage.addChild(title)
                title.buttonMode = true
                title.on('pointerdown', function ()
                {
                    self.setPage("howToPlay")
                })
                title.interactive = true
                self.hierarchy.title.title = title
                
                const logo = new PIXI.Sprite( textureMap['imgP1Logo'].texture )
                logo.x = app.renderer.width * 0.5
                logo.y = app.renderer.height * 0.8
                logo.anchor.x = 0.5
                logo.anchor.y = 0.5
                app.stage.addChild(logo)
                self.hierarchy.title.logo = logo
            }

            //------ How To Play Page ------//
            {
                self.hierarchy.howToPlay.textbox = addSprite('imgP2Textbox', 0.5, 0.5, 1.2)
                self.hierarchy.howToPlay.title = addSprite('imgP2Title', 0.25, 0.1, 1.2)
                self.hierarchy.howToPlay.start = addSprite('imgP2Start', 0.85, 0.9, 1.2)
                self.hierarchy.howToPlay.start.interactive = true
                self.hierarchy.howToPlay.start.on('pointerdown', function ()
                {
                    self.setPage("characterCreator")
                })
                self.hierarchy.howToPlay.desc = new PIXI.Text(                
                        "● บอกความเป็นคุณให้เรารู้สักหน่อย" + "\n" +
                        "● คลิกเลือกผักผลไม้ที่ต้องการกิน ในหนึ่งวันใส่ลงตระกร้า โดยหยิบแต่ละอย่าง ได้มากกว่า 1 ชิ้น" + "\n" +
                        "● เลือกแล้วเปลี่ยนใจเทลงถังขยะได้" + "\n" +
                        "● เลือกผักผลไม้ได้ทั้งหมด ไม่เกิน 10 ชนิด" + "\n" +
                        "● เมื่อเลือกครบ 10 ชนิด กดปุ่ม OK ระบบจะแสดงปริมาณ ผักผลไม้ที่คุณเลือกกิน ในหนึ่งวันให้รู้",
                    new PIXI.TextStyle({
                        fontFamily: "Mitr",
                        fontSize: 40,
                        fill: "#855723",
                        lineHeight: 48 + 20,
                        wordWrap: true,
                        wordWrapWidth: app.renderer.width * 0.75
                    })
                )
                self.hierarchy.howToPlay.desc.position.set(app.renderer.width * 0.14, app.renderer.height * 0.22)
                app.stage.addChild(self.hierarchy.howToPlay.desc)
            }

            //------ Character Creator ------//
            {
                let rect = [ app.renderer.width * 0.5, app.renderer.height*0.5, 250, 50 ]
                self.hierarchy.characterCreator.avatar = addSprite('imgP3Avatar', 0.5, 0.25, 1.2)
                const graphics = new PIXI.Graphics()

                for(let i = 0; i < 3; ++i) {                
                    graphics.beginFill(0xFFFFFF);
                    graphics.drawRect(rect[0] - rect[2], rect[1] - rect[3], rect[2] * 2, rect[3] * 2)
                    graphics.endFill()
                    graphics.lineStyle(0)
                    graphics.beginFill(0xFFFFFF, 1)
                    graphics.drawCircle(rect[0] - rect[2], rect[1], rect[3])
                    graphics.endFill()
                    graphics.lineStyle(0)
                    graphics.beginFill(0xFFFFFF, 1)
                    graphics.drawCircle(rect[0] + rect[2], rect[1], rect[3])
                    graphics.endFill()

                    if(i < 2)
                        rect[1] += 130
                }

                app.stage.addChild(graphics)
                self.hierarchy.characterCreator.capsule = graphics

                self.hierarchy.characterCreator.label = new PIXI.Text(                
                        "ชื่อ\nอายุ\nเพศ",
                    new PIXI.TextStyle({
                        fontFamily: "Mitr",
                        fontSize: 64,
                        fill: "#855723",
                        lineHeight: 72 + 58,
                    })
                )
                self.hierarchy.characterCreator.label.position.set(app.renderer.width * 0.3, app.renderer.height * 0.45 + 10)
                app.stage.addChild(self.hierarchy.characterCreator.label)

                {
                    let textField = new TextInput({
                        input: {
                            fontFamily: "Mitr",
                            fontSize: '36pt',
                            padding: '4px',
                            width: '400px',
                            color: '#855723'
                        }, 
                        box: {
                            box: {fill: 0xE8E9F3, rounded: 16, stroke: {color: 0xCBCEE0, width: 4}}
                            // default: {fill: 0xE8E9F3, rounded: 16, stroke: {color: 0xCBCEE0, width: 4}},
                            // focused: {fill: 0xE1E3EE, rounded: 16, stroke: {color: 0xABAFC6, width: 4}},
                            // disabled: {fill: 0xDBDBDB, rounded: 16}
                        },
                    })
                    textField.placeholder = 'กรอกชื่อของคุณ...'
                    app.stage.addChild(textField)
                    textField.position.set(
                        app.renderer.width * 0.3 + 120,
                        app.renderer.height * 0.45 + 10
                    )
                    textField.on('input', text => {
                        self.gameData.name = text
                    })
                    textField.focus()
                    self.hierarchy.characterCreator.textFieldName = textField
                }

                {
                    let textField = new TextInput({
                        input: {
                            fontFamily: "Mitr",
                            fontSize: '36pt',
                            padding: '4px',
                            width: '400px',
                            color: '#855723'
                        }, 
                        box: {
                            box: {fill: 0xE8E9F3, rounded: 16, stroke: {color: 0xCBCEE0, width: 4}}
                            // default: {fill: 0xE8E9F3, rounded: 16, stroke: {color: 0xCBCEE0, width: 4}},
                            // focused: {fill: 0xE1E3EE, rounded: 16, stroke: {color: 0xABAFC6, width: 4}},
                            // disabled: {fill: 0xDBDBDB, rounded: 16}
                        },
                    })
                    textField.placeholder = '15'
                    // textField.restrict = /[0-9]|\./;
                    app.stage.addChild(textField)
                    textField.position.set(
                        app.renderer.width * 0.5,
                        app.renderer.height * 0.45 + 10 + (72 + 58)
                    )
                    textField.on('input', text => {
                        let tryParseAge = parseInt( text )
                        if( isNaN(tryParseAge) ) {
                            textField._dom_input.value = ""
                        } else {
                            self.gameData.age = Math.max(0, Math.min(tryParseAge, 150))
                            textField._dom_input.value = self.gameData.age
                        }
                    })
                    textField.focus()
                    self.hierarchy.characterCreator.textFieldAge = textField
                }

                let selectList = []
                let dropdownStyle = new PIXI.TextStyle({
                        fontFamily: "Mitr",
                        fontSize: 52,
                        fill: "#855723",
                        stroke: '#FFFFFF',
                        strokeThickness: 60,
                        // dropShadow: true,
                        // dropShadowColor: "#000000",
                        // dropShadowBlur: 4,
                        // dropShadowAngle: Math.PI / 6,
                        // dropShadowDistance: 6,
                })
                self.hierarchy.characterCreator.selectGenderN = new PIXI.Text( "  -  ", dropdownStyle)
                selectList.push( self.hierarchy.characterCreator.selectGenderN )
                selectList[0].position.set(app.renderer.width * 0.5, rect[1] - 60)
                app.stage.addChild(selectList[0])                
                selectList[0].interactive = true
                selectList[0].hitArea = new PIXI.Rectangle(0, 0, 150, 100)
                selectList[0].on('pointerdown', function ()
                {
                    if(self.genderDropdownState.expand) {
                        self.genderDropdownState.value = 'N'
                        self.genderDropdownState.expand = false
                    } else {
                        self.genderDropdownState.expand = true
                    }
                    self.updateGenderDropdownDisplay()
                })

                self.hierarchy.characterCreator.selectGenderM = new PIXI.Text( "ชาย", dropdownStyle)
                selectList.push( self.hierarchy.characterCreator.selectGenderM )
                selectList[1].position.set(app.renderer.width * 0.5, rect[1] - 60 + 70)
                app.stage.addChild(selectList[1])                
                selectList[1].interactive = true
                selectList[1].hitArea = new PIXI.Rectangle(0, 0, 150, 100)
                selectList[1].on('pointerdown', function ()
                {
                    if(self.genderDropdownState.expand) {
                        self.genderDropdownState.value = 'M'
                        self.genderDropdownState.expand = false
                        self.updateGenderDropdownDisplay()
                    } 
                })

                self.hierarchy.characterCreator.selectGenderF = new PIXI.Text( "หญิง", dropdownStyle)
                selectList.push( self.hierarchy.characterCreator.selectGenderF )
                selectList[2].position.set(app.renderer.width * 0.5, rect[1] - 60 + 140)
                app.stage.addChild(selectList[2])                
                selectList[2].interactive = true
                selectList[2].hitArea = new PIXI.Rectangle(0, 0, 150, 100)
                selectList[2].on('pointerdown', function ()
                {
                    if(self.genderDropdownState.expand) {
                        self.genderDropdownState.value = 'F'
                        self.genderDropdownState.expand = false
                        self.updateGenderDropdownDisplay()
                    } 
                })

                self.eventDispatcher.listenToEvent(
                    "pageChanged",
                    function(payload) {
                        if(payload.curr == "characterCreator")
                            self.updateGenderDropdownDisplay()
                    }
                )

                self.hierarchy.characterCreator.next = addSprite('imgP3Next', 0.85, 0.9, 1.2)
                self.hierarchy.characterCreator.next.interactive = true
                self.hierarchy.characterCreator.next.on('pointerdown', function ()
                {
                    if( self.gameData.name == "" ) {
                        alert("อย่าลืมกรอกชื่อผู้เล่นด้วยนะ!")
                    } else {
                        self.gameData.gender = self.genderDropdownState.value
                        self.setPage("characterProfile")
                    }
                })
            }

            //------ Character Profile ------//
            {
                const graphics = new PIXI.Graphics()
                graphics.lineStyle(0)
                graphics.beginFill(0xe37000, 1)
                graphics.drawCircle(app.renderer.width * 0.5, app.renderer.height*0.4, 208)
                graphics.endFill()
                app.stage.addChild(graphics)
                self.hierarchy.characterProfile.circle = graphics

                self.hierarchy.characterProfile.avatar = addSprite('imgP4Player1', 0.5, 0.4, 1)
                self.hierarchy.characterProfile.avatar.y += 8
                self.hierarchy.characterProfile.next = addSprite('imgP3Next', 0.85, 0.9, 1.2)
                self.hierarchy.characterProfile.next.interactive = true
                self.hierarchy.characterProfile.next.on('pointerdown', function ()
                {
                    self.setPage("gameplay")
                })
                self.eventDispatcher.listenToEvent(
                    "pageChanged",
                    function(payload) {
                        if(payload.curr == "characterProfile") {
                            self.hierarchy.characterProfile.avatar.texture = textureMap[ 
                                GENDER_TEXTURE_MAP[
                                    self.gameData.gender
                                ]
                            ].texture

                            self.hierarchy.characterProfile.playerName.text = self.gameData.name
                        }
                    }
                )
                self.hierarchy.characterProfile.playerName = new PIXI.Text(                
                        "ชื่อผู้เล่น",
                    new PIXI.TextStyle({
                        fontFamily: "Mitr",
                        fontSize: 96,
                        fill: "#855723",
                        
                    })
                )
                self.hierarchy.characterProfile.playerName.anchor.x = 0.5
                self.hierarchy.characterProfile.playerName.anchor.y = 0.5
                self.hierarchy.characterProfile.playerName.position.set(app.renderer.width * 0.5, app.renderer.height * 0.7)
                app.stage.addChild(self.hierarchy.characterProfile.playerName)
            }

            //------ Gameplay ------//
            {
                self.hierarchy.gameplay.kitchen = addSprite('imgP5Kitchen', 0.5, 0.5, 1.2)
                self.hierarchy.gameplay.kitchen.alpha = 0.8
                //Add veggie icon
                {
                    let startX = app.renderer.width * 0.12
                    let startY = app.renderer.height * 0.17
                    let margin = 140
                    let i = 0
                    let scale = 1.2
                    for(let row = 0; row < 5; ++row) {
                        for(let col = 0; col < 8; ++col) {
                            let index = i
                            let posX = startX + col * margin
                            let posY = startY + row * margin

                            let sp = addSprite(
                                "veggieIcon" + (index+1),
                                posX / app.renderer.width,
                                posY / app.renderer.height,
                                scale
                            )
                            sp.interactive = true
                            sp.on('pointerdown', function ()
                            {
                                if(self.checkPopupExist())
                                    return

                                self.gameState.selectedVeggie = index
                                self.popups.veggieInfo.info.texture = textureMap[ 'veggieDetail' + (self.gameState.selectedVeggie + 1) ].texture
                                self.showPopup("veggieInfo")                             
                                self.popups.veggieInfo.add.visible = self.getNumberOfCartItemType() < 10
                            })
                            self.hierarchy.gameplay[ "veggieIcon" + (index+1) ] = sp
                            ++i
                        }
                    }                        
                }
                //

                self.hierarchy.gameplay.basket = addSprite('imgP5Basket', 0.95, 0.2, 1.2)
                self.hierarchy.gameplay.basket.interactive = true
                
                let showCartPopup
                showCartPopup = function() {
                    self.showPopup("cart")
                    let i = 0
                    let positionList = getVeggiePositionList(0)
                    _.keys(self.gameState.cart).forEach( (key) => {
                        if( self.gameState.cart[key] > 0 ) {
                            let pos = positionList[i]
                            let sp = addSprite(
                                'veggieIcon' + ( parseInt(key) + 1),
                                pos.x / app.renderer.width,
                                pos.y / app.renderer.height,
                                0.8
                            )

                            let deleteBtn = addSprite(
                                'imgP5Trash',
                                (sp.x + 200) / app.renderer.width,
                                sp.y / app.renderer.height,
                                1.2
                            )
                            deleteBtn.interactive = true
                            deleteBtn.on('pointerdown', function ()
                            {
                                --self.gameState.cart[ key ]
                                self.updateCartAmountLabel()
                                self.resetVeggiePool()
                                self.hideAllPopup()
                                showCartPopup()

                                if( self.getNumberOfCartItemType() < 10 ) {
                                    self.hierarchy.gameplay.ok.visible = false
                                }
                            })

                            let label = new PIXI.Text(                
                                    'x ' + self.gameState.cart[key],
                                new PIXI.TextStyle({
                                    fontFamily: "Mitr",
                                    fontSize: 40,
                                    fill: "#855723",                        
                                })
                            )
                            label.anchor.x = 0
                            label.anchor.y = 0.5
                            label.position.set(sp.x + 65, sp.y)
                            app.stage.addChild(label)

                            self.veggiePool.push({
                                sp: sp,
                                label: label,
                                delete: deleteBtn,
                            })
                            ++i
                        }
                    })
                }
                
                self.hierarchy.gameplay.basket.on('pointerdown', function ()
                {
                    if(self.checkPopupExist())
                        return
                    
                    showCartPopup()
                })
                self.hierarchy.gameplay.timer = new PIXI.Text(                
                        '--:--',
                    new PIXI.TextStyle({
                        fontFamily: "Mitr",
                        fontSize: 80,
                        fill: "#FFFFFF",                    
                    })
                )
                self.hierarchy.gameplay.timer.anchor.x = 0.5
                self.hierarchy.gameplay.timer.anchor.y = 0.5
                self.hierarchy.gameplay.timer.position.set(app.renderer.width * 0.865, app.renderer.height * 0.89)
                app.stage.addChild(self.hierarchy.gameplay.timer)

                self.hierarchy.gameplay.ok = new PIXI.Text(                
                        'OK',
                    new PIXI.TextStyle({
                        fontFamily: "Mitr",
                        fontSize: 80,
                        fill: "#FFFFFF",                    
                    })
                )
                self.hierarchy.gameplay.ok.anchor.x = 0.5
                self.hierarchy.gameplay.ok.anchor.y = 0.5
                self.hierarchy.gameplay.ok.position.set(app.renderer.width * 0.865, app.renderer.height * 0.89)
                app.stage.addChild(self.hierarchy.gameplay.ok)
                self.hierarchy.gameplay.ok.interactive = true
                self.hierarchy.gameplay.ok.hitArea = new PIXI.Rectangle(-75, -50, 150, 100)
                self.hierarchy.gameplay.ok.on('pointerdown', function ()
                {
                        self.stopGameplay()
                        self.hideAllPopup()
                        self.setPage("summary")
                })

                self.hierarchy.gameplay.cartAmount = new PIXI.Text(                
                        '0',
                    new PIXI.TextStyle({
                        fontFamily: "Mitr",
                        fontSize: 30,
                        fill: "#855723",                        
                    })
                )
                self.hierarchy.gameplay.cartAmount.anchor.x = 0.5
                self.hierarchy.gameplay.cartAmount.anchor.y = 0.5
                self.hierarchy.gameplay.cartAmount.position.set(app.renderer.width * 0.975, app.renderer.height * 0.17)
                app.stage.addChild(self.hierarchy.gameplay.cartAmount)

                self.eventDispatcher.listenToEvent(
                    "pageChanged",
                    function(payload) {
                        if(payload.curr == "gameplay") {
                            self.startGameplay()
                        }
                        if(payload.prev == "gameplay") {
                            self.resetVeggiePool()
                        }
                    }
                )
            }

            //------ Summary ------//
            {
                self.hierarchy.summary.textbox = addSprite('imgP2Textbox', 0.5, 0.38, 1.2)
                self.hierarchy.summary.weightScale = addSprite('imgP6Scale', 0.5, 0.8, 0.8)
                self.hierarchy.summary.next = addSprite('imgP6Next', 0.87, 0.85, 1.2)
                self.hierarchy.summary.next.interactive = true
                self.hierarchy.summary.next.on('pointerdown', function ()
                {
                    self.setPage("result")
                })
                self.eventDispatcher.listenToEvent(
                    "pageChanged",
                    function(payload) {
                        if(payload.curr == "summary") {

                            if( self.getCartItemsAmount() <= 0 ) {
                                self.setPage("result")
                                return
                            }

                            let i = 0
                            let positionList = getVeggiePositionList(1)
                            _.keys(self.gameState.cart).forEach( (key) => {
                                if( self.gameState.cart[key] > 0 ) {
                                    let pos = positionList[i]
                                    let sp = addSprite(
                                        'veggieIcon' + ( parseInt(key) + 1),
                                        pos.x / app.renderer.width,
                                        pos.y / app.renderer.height,
                                        0.8
                                    )

                                    let label = new PIXI.Text(                
                                            'x ' + self.gameState.cart[key] + ' '+ VEGGIE_WEIGHT[ parseInt(key) ][2] + ' = ' + VEGGIE_WEIGHT[ parseInt(key) ][1] * self.gameState.cart[key] + ' ก.',
                                        new PIXI.TextStyle({
                                            fontFamily: "Mitr",
                                            fontSize: 40,
                                            fill: "#855723",                        
                                        })
                                    )
                                    label.anchor.x = 0
                                    label.anchor.y = 0.5
                                    label.position.set(sp.x + 65, sp.y)
                                    app.stage.addChild(label)

                                    self.veggiePool.push({
                                        sp: sp,
                                        label: label,
                                    })
                                    ++i
                                }
                            })
                        }
                        if(payload.prev == "summary") {
                            self.resetVeggiePool()
                        }
                    }
                )
            }

            //------ Result ------//
            {
                self.hierarchy.result.textbox = addSprite('imgP7Textbox', 0.55, 0.48, 1.2)
                self.hierarchy.result.player = addSprite('imgP7Player1', 0.21, 0.67, 1.2)
                
                self.hierarchy.result.header = new PIXI.Text(                
                        "คุณเลือกผักผลไม้ xxx กรัม",
                    new PIXI.TextStyle({
                        fontFamily: "Mitr",
                        fontSize: 96,
                        fill: "#FFFFFF",
                        
                    })
                )
                self.hierarchy.result.header.anchor.x = 0.5
                self.hierarchy.result.header.anchor.y = 0.5
                self.hierarchy.result.header.position.set(app.renderer.width * 0.5, app.renderer.height * 0.15)
                app.stage.addChild(self.hierarchy.result.header)

                self.hierarchy.result.desc = new PIXI.Text(                
                        "เยี่ยมเลย! คุณเลือกหยิบ\nผัก ผลไม้ ได้ตามสัดส่วน\nผัก 3 ส่วน / ผลไม้ 2 ส่วน",
                    new PIXI.TextStyle({
                        fontFamily: "Mitr",
                        fontSize: 64,
                        fill: "#000000",
                        
                    })
                )
                self.hierarchy.result.desc.anchor.x = 0.5
                self.hierarchy.result.desc.anchor.y = 0.5
                self.hierarchy.result.desc.position.set(app.renderer.width * 0.55, app.renderer.height * 0.48)
                app.stage.addChild(self.hierarchy.result.desc)

                self.hierarchy.result.share = new PIXI.Text(                
                        " แชร์กับเพื่อน",
                    new PIXI.TextStyle({
                        fontFamily: "Mitr",
                        fontSize: 48,
                        fill: "#000000",
                        
                    })
                )
                self.hierarchy.result.share.anchor.x = 0.5
                self.hierarchy.result.share.anchor.y = 0.5
                self.hierarchy.result.share.position.set(app.renderer.width * 0.35, app.renderer.height * 0.8)
                app.stage.addChild(self.hierarchy.result.share)

                self.hierarchy.result.playAgain = addSprite('imgP7PlayAgain', 0.85, 0.88, 1.2)
                self.hierarchy.result.playAgain.interactive = true
                self.hierarchy.result.playAgain.on('pointerdown', function ()
                {
                    self.setPage("title")
                })

                self.hierarchy.result.fb = addSprite('imgP7FB', 0.3, 0.88, 1.2)
                self.hierarchy.result.fb.interactive = true
                self.hierarchy.result.fb.on('pointerdown', function ()
                {
                    self.$refs.shareNetworkFB.click()
                })
                self.hierarchy.result.line = addSprite('imgP7Line', 0.3 + 0.07, 0.88, 1.2)
                self.hierarchy.result.line.interactive = true
                self.hierarchy.result.line.on('pointerdown', function ()
                {
                    self.$refs.shareNetworkLine.click()
                })
                self.hierarchy.result.twitter = addSprite('imgP7Twitter', 0.3 + 0.14, 0.88, 1.2)
                self.hierarchy.result.twitter.interactive = true
                self.hierarchy.result.twitter.on('pointerdown', function ()
                {
                    self.$refs.shareNetworkTwitter.click()
                })


                self.eventDispatcher.listenToEvent(
                    "pageChanged",
                    function(payload) {
                        if(payload.curr == "result") {
                            const getVeggieWeight = function(key, amount) {
                                return VEGGIE_WEIGHT[ key ][1] * amount
                            }

                            const getSumVegetableAndFruitWeight = function() {
                                let sumVeggieWeight = 0
                                let sumFruitWeight = 0
                                _.keys(self.gameState.cart).forEach( (key) => {                
                                    if( self.gameState.cart[key] > 0 ) {
                                        if( key < START_FRUIT_INDEX )
                                            sumVeggieWeight += getVeggieWeight(key, self.gameState.cart[key])
                                        else
                                            sumFruitWeight += getVeggieWeight(key, self.gameState.cart[key])
                                    }
                                })
                                return {
                                    veggie: sumVeggieWeight,
                                    fruit: sumFruitWeight,
                                }
                            }

                            const verifyEnoughWeight = function() {
                                let sumWeight = getSumVegetableAndFruitWeight()

                                return (sumWeight.veggie + sumWeight.fruit) >= 
                                    (self.verifyAdult() ? VERIFY_WEIGHT_THRESHOLD.ADULT : VERIFY_WEIGHT_THRESHOLD.KID)
                            }

                            const verifyVeggieFruitRatio = function() {
                                if( !self.verifyAdult() )
                                    return true

                                let sumWeight = getSumVegetableAndFruitWeight()
                                let choosenRatio = sumWeight.veggie / sumWeight.fruit

                                return choosenRatio >= VEGGIE_FRUIT_RATIO
                            }

                            const verifyEnoughVeggieWeight = function() {
                                let sumWeight = getSumVegetableAndFruitWeight()

                                return sumWeight.veggie >= 
                                    (self.verifyAdult() ? VERIFY_WEIGHT_THRESHOLD.ADULT : VERIFY_WEIGHT_THRESHOLD.KID) * 0.6
                            }

                            const verifyEnoughFruitWeight = function() {
                                let sumWeight = getSumVegetableAndFruitWeight()

                                return sumWeight.fruit >= 
                                    (self.verifyAdult() ? VERIFY_WEIGHT_THRESHOLD.ADULT : VERIFY_WEIGHT_THRESHOLD.KID) * 0.4
                            }

                            let sumWeight = getSumVegetableAndFruitWeight()
                            self.gameData.weight = sumWeight.veggie + sumWeight.fruit
                                
                            self.gameData.enough = verifyEnoughWeight()
                            self.gameData.enoughVeggie = verifyEnoughVeggieWeight()
                            self.gameData.enoughFruit = verifyEnoughFruitWeight()
                            self.gameData.ratio = verifyVeggieFruitRatio()

                            self.hierarchy.result.player.texture = textureMap[ 
                                self.gameData.gender == 'N' ?
                                "imgP7Player1" : self.gameData.gender == 'M' ? "imgP7Player2" : "imgP7Player3"
                            ].texture

                            self.hierarchy.result.header.text = "คุณเลือกผักผลไม้ " + self.gameData.weight + " กรัม"

                            if( self.gameData.enough ) {
                                if( self.gameData.enoughVeggie && self.gameData.enoughFruit ) {
                                    self.hierarchy.result.desc.text = "เยี่ยมเลย! คุณเลือกหยิบ\nผัก ผลไม้ ได้ตามสัดส่วน\nผัก 3 ส่วน / ผลไม้ 2 ส่วน"
                                } else if( !self.gameData.enoughVeggie ) {
                                    self.hierarchy.result.desc.text = "เลือกหยิบผลไม้แล้ว\nลองเพิ่มหยิบผัก\nมาเติมบ้างสิ"
                                } else if( !self.gameData.enoughFruit ) {
                                    self.hierarchy.result.desc.text = "เลือกหยิบผักแล้ว\nลองเพิ่มหยิบผลไม้\nมาเติมบ้างสิ"
                                }

                                /*
                                if( self.gameData.ratio ) {
                                    self.hierarchy.result.desc.text = "เยี่ยมเลย! คุณเลือกหยิบ\nผัก ผลไม้ ได้ตามสัดส่วน\nผัก 3 ส่วน / ผลไม้ 2 ส่วน"
                                } else {
                                    // self.hierarchy.result.desc.text = "ปริมาณที่เลือกยังน้อยไปนะ\nลองหยิบผัก\nมาเติมบ้างสิ"
                                    self.hierarchy.result.desc.text = "เลือกหยิบผลไม้แล้ว\nลองเพิ่มหยิบผัก\nมาเติมบ้างสิ"
                                }
                                */
                            } else {
                                // if( self.gameData.ratio ) {
                                //     // self.hierarchy.result.desc.text = "เลือกหยิบผลไม้แล้ว\nลองเพิ่มหยิบผัก\nมาเติมบ้างสิ"
                                //     // self.hierarchy.result.desc.text = "ปริมาณที่เลือกยังน้อยไปนะ\nลองหยิบผักหรือผลไม้\nมาเติมบ้างสิ"
                                //     self.hierarchy.result.desc.text = "เลือกหยิบผักแล้ว\nลองเพิ่มหยิบผลไม้\nมาเติมบ้างสิ"
                                // } else {
                                //     // self.hierarchy.result.desc.text = "เลือกหยิบผักแล้ว\nลองเพิ่มหยิบผลไม้\nมาเติมบ้างสิ"
                                //     self.hierarchy.result.desc.text = "เลือกหยิบผลไม้แล้ว\nลองเพิ่มหยิบผัก\nมาเติมบ้างสิ"
                                // }
                                self.hierarchy.result.desc.text = "คุณเลือกปริมาณผัก\nผลไม้ยังไม่ถึง "
                                    + (self.verifyAdult() ? VERIFY_WEIGHT_THRESHOLD.ADULT : VERIFY_WEIGHT_THRESHOLD.KID)
                                    + " กรัม"
                            }

                            //Post log to DB
                            const getCartDataString = function() {
                                let result = ""
                                _.keys(self.gameState.cart).forEach( (key) => {                
                                    if( self.gameState.cart[key] > 0 ) {
                                        if( result != "" )
                                            result += ","
                                        
                                        result += key
                                        result += "="
                                        result += self.gameState.cart[key]
                                    }
                                })
                                return result
                            }
                            
                            axios.post(
                                config.BASE_URL + "/veggiegame", 
                                {
                                    "playername" : self.gameData.name,
                                    "gender" : self.gameData.gender,
                                    "age" : self.gameData.age,
                                    "veggies" : getCartDataString(),
                                    "result" : "adult=" 
                                        + (self.verifyAdult() ? '1' : '0')
                                        + ",veggie="
                                        + (self.gameData.enoughVeggie ? '1' : '0')
                                        + ",fruit="
                                        + (self.gameData.enoughFruit ? '1' : '0')
                                        + ",weight="
                                        + (self.gameData.weight),
                                },
                                config.JSON_HEADER_CONFIG
                            )
                            .then((res) => {
                                console.log(res.data)
                            })
                            .catch((err) => {
                                console.log("AXIOS ERROR: ", err)
                            })
                        }
                    }
                )
            }

            //------ Timeups Popup ------//
            {
                const graphics = new PIXI.Graphics()
                graphics.beginFill(0xFFFFFF, 0.7)
                graphics.drawRect(0, 0, app.renderer.width, app.renderer.height)
                graphics.endFill()
                app.stage.addChild(graphics)
                self.popups.timesup.rect = graphics
                self.popups.timesup.timeup = addSprite('imgP5TimeUp', 0.5, 0.5, 1.2)
            }

            //------ Cart Popup ------//
            {
                const graphics = new PIXI.Graphics()
                graphics.beginFill(0xFFFFFF, 0.7)
                graphics.drawRect(0, 0, app.renderer.width, app.renderer.height)
                graphics.endFill()
                app.stage.addChild(graphics)
                self.popups.cart.rect = graphics
                self.popups.cart.box = addSprite('imgP5SumBox', 0.5, 0.5, 1.2)
                self.popups.cart.close = addSprite('imgP5Close', 0.835, 0.22, 1.5)
                self.popups.cart.close.interactive = true
                self.popups.cart.close.on('pointerdown', function ()
                {
                    self.resetVeggiePool()
                    self.hideAllPopup()
                })
            }

            //------ Veggie Reach Popup ------//
            {
                const graphics = new PIXI.Graphics()
                graphics.beginFill(0xFFFFFF, 0.7)
                graphics.drawRect(0, 0, app.renderer.width, app.renderer.height)
                graphics.endFill()
                app.stage.addChild(graphics)
                self.popups.veggieReach.rect = graphics
                self.popups.veggieReach.desc = new PIXI.Text(                
                        "เลือกผักครบ 10 ชนิดแล้ว",
                    new PIXI.TextStyle({
                        fontFamily: "Mitr",
                        fontSize: 80,
                        fill: "#FFFFFF",

                        stroke: '#e37000',
                        strokeThickness: 8,
                        dropShadow: true,
                        dropShadowColor: "#e37000",
                        dropShadowBlur: 4,
                        dropShadowAngle: Math.PI / 6,
                        dropShadowDistance: 6,
                        
                    })
                )
                self.popups.veggieReach.desc.anchor.x = 0.5
                self.popups.veggieReach.desc.anchor.y = 0.5
                self.popups.veggieReach.desc.position.set(app.renderer.width * 0.5, app.renderer.height * 0.5)
                app.stage.addChild(self.popups.veggieReach.desc)
            }

            //------ Veggie Info Popup ------//
            {
                const graphics = new PIXI.Graphics()
                graphics.beginFill(0xFFFFFF, 0.7)
                graphics.drawRect(0, 0, app.renderer.width, app.renderer.height)
                graphics.endFill()
                app.stage.addChild(graphics)
                self.popups.veggieInfo.rect = graphics
                self.popups.veggieInfo.info = addSprite('veggieDetail1', 0.5, 0.45, 1.2)
                self.popups.veggieInfo.add = addSprite('imgP5Add', 0.5, 0.8, 1.2)
                self.popups.veggieInfo.add.interactive = true
                self.popups.veggieInfo.add.on('pointerdown', function ()
                {
                    ++self.gameState.cart[ self.gameState.selectedVeggie ]
                    self.updateCartAmountLabel()
                    self.hideAllPopup()
                    //DEBUG - End game when choose 10 items
                    // if( self.getNumberOfCartItemType() >= 10 ) {
                    //     self.gameState.min = 0
                    //     self.gameState.second = 0
                    // }

                    if( self.getNumberOfCartItemType() >= 10 ) {
                        self.hierarchy.gameplay.ok.visible = true
                    }
                    if( self.getNumberOfCartItemType() == 10 ) {
                        self.showPopup("veggieReach")
                        setTimeout( () => {
                            self.hideAllPopup()
                        }, 3000 )
                    }
                })
                self.popups.veggieInfo.close = addSprite('imgP5Close', 0.72, 0.22, 1.5)
                self.popups.veggieInfo.close.interactive = true
                self.popups.veggieInfo.close.on('pointerdown', function ()
                {
                    self.hideAllPopup()
                })
            }

            //Test text
            {
                //Add text
                let message = new PIXI.Text(
                    "สวัสดี Pixi!",
                    new PIXI.TextStyle({
                        fontFamily: "Mitr",
                        fontSize: 36,
                        fill: "white",
                        stroke: '#ff3300',
                        strokeThickness: 4,
                        dropShadow: true,
                        dropShadowColor: "#000000",
                        dropShadowBlur: 4,
                        dropShadowAngle: Math.PI / 6,
                        dropShadowDistance: 6,
                    })
                )
                // app.stage.addChild(message)
                message.position.set(54, 96)

                let textField = new TextInput({
                    input: {
                        fontFamily: "Mitr",
                        fontSize: '25pt',
                        padding: '14px',
                        width: '500px',
                        color: '#26272E'
                    }, 
                    box: {
                        // box: {fill: 0xE8E9F3, rounded: 16, stroke: {color: 0xCBCEE0, width: 4}}
                        default: {fill: 0xE8E9F3, rounded: 16, stroke: {color: 0xCBCEE0, width: 4}},
                        focused: {fill: 0xE1E3EE, rounded: 16, stroke: {color: 0xABAFC6, width: 4}},
                        disabled: {fill: 0xDBDBDB, rounded: 16}
                    },
                })
                textField.placeholder = 'Enter your Text...'
                // app.stage.addChild(textField)
                textField.position.set(54, 96 + 60)
                textField.on('input', text => {
                    // console.log('textField:', text)
                })
                // textField.focus()
                //
            }

            window.addEventListener("resize", self.resize);
            self.resize()

            app.ticker.add(delta => self.gameLoop(delta))
            
            _.keys(self.hierarchy).forEach( (page) => {
                if(page != "none" && page != "shared") {
                   _
                   .chain(self.hierarchy[page])
                    .forEach((elem) => {
                        elem.visible = false
                        // elem.interactive = false
                    })
                    .value()
                }
            })
                
            self.hideAllPopup()            
            self.setPage("title")            
        })
    },    
    methods: {
        // ...mapActions({
        //     readItemAsync: types.READ_ITEM_ASYNC,
        // }),
        // ...mapMutations({
        //     setItem: types.SET_ITEM,
        // }),
        forceRerender() {
            this.reRenderKey += 1;  
        },
        startGameplay() {
            const self = this
            self.resetGameState()
            // self.hierarchy.gameplay.timer.text = '--:--'
            self.hierarchy.gameplay.timer.text = ""
            self.hierarchy.gameplay.ok.visible = false
            self.updateCartAmountLabel()
            self.hideAllPopup()
            // self.gameState.interval = setInterval(
            //     function(){
            //         self.hierarchy.gameplay.timer.text =                     
            //             ""
            //             + ("00" + self.gameState.min).substr(-2,2)
            //             + ":"
            //             + ("00" + self.gameState.second).substr(-2,2)                    

            //         if( self.gameState.min <= 0 && self.gameState.second <= 0 ) {
            //             self.stopGameplay()
            //             self.showPopup("timesup")
            //             setTimeout(function() {
            //                 self.hideAllPopup()
            //                 self.setPage("summary")
            //             }, 2000)
            //             return       
            //         }

            //         --self.gameState.second
            //         if( self.gameState.second < 0 ) {
            //             --self.gameState.min
            //             self.gameState.second = 59
            //         }
            //     },
            //     1000
            // )
        },
        stopGameplay() {
            const self = this
            clearInterval( self.gameState.interval )
            self.resetVeggiePool()
            self.hideAllPopup()
        },
        resetGameState() {
            this.gameState = getInitialGameState()
        },
        resetVeggiePool() {
            const self = this
            let amount = self.veggiePool.length
            for( let i = 0; i < amount; ++i) {
                self.app.stage.removeChild(
                    self.veggiePool[i].sp
                )
                self.app.stage.removeChild(
                    self.veggiePool[i].label
                )
                if( self.veggiePool[i].hasOwnProperty( 'delete' ) )
                    self.app.stage.removeChild(
                        self.veggiePool[i].delete
                    )
            }
            self.veggiePool = []
        },
        getCartItemsAmount() {
            const self = this

            let sum = 0
            _.keys(self.gameState.cart).forEach( (key) => {
                sum += self.gameState.cart[key]
            })
            return sum
        },
        getNumberOfCartItemType() {
            const self = this

            let count = 0
            _.keys(self.gameState.cart).forEach( (key) => {
                if( self.gameState.cart[key] > 0 )
                    ++count
            })
            return count
        },
        updateCartAmountLabel() {
            this.hierarchy.gameplay.cartAmount.text = '' + this.getCartItemsAmount()
        },
        checkPopupExist() {
            return this.popupState != ""
        },
        verifyAdult() {
            return this.gameData.age >= ADULT_AGE
        },
        showPopup(popupName) {
            const self = this

            _
                .chain(self.popups[ popupName ])
                .forEach((elem) => {
                    elem.visible = true
                })
                .value()

            self.popupState = popupName
        },
        hideAllPopup() {
            const self = this

            _.keys(self.popups).forEach((key) => {
                _
                .chain(self.popups[ key ])
                .forEach((elem) => {
                    elem.visible = false
                })
                .value()
            })

            self.popupState = ""
        },
        setPage(state) {
            const self = this
            if( self.pageState.curr != "none" ) {
                _
                    .chain(self.hierarchy[ self.pageState.curr ])
                    .forEach((elem) => {
                        elem.visible = false
                        // elem.interactive = false
                    })
                    .value()
            }

            self.pageState.prev = self.pageState.curr

            self.pageState.curr = state

            _
                .chain(self.hierarchy[ self.pageState.curr ])
                .forEach((elem) => {
                    elem.visible = true
                    // elem.interactive = true
                })
                .value()
                
            self.eventDispatcher.fireEvent(
                "pageChanged",
                {
                    prev: self.pageState.prev,
                    curr: self.pageState.curr,
                },
            )
        },
        setBackgroundTexture(textureName) {
            this.hierarchy.shared.tilingSprite.texture = this.textureMap[ textureName ].texture
        },
        updateGenderDropdownDisplay() {
            const self = this

            if( self.genderDropdownState.expand ) {
                self.hierarchy.characterCreator.selectGenderM.visible = true
                self.hierarchy.characterCreator.selectGenderF.visible = true

                self.hierarchy.characterCreator.selectGenderN.text = "  -  "
            } else {
                self.hierarchy.characterCreator.selectGenderM.visible = false
                self.hierarchy.characterCreator.selectGenderF.visible = false

                self.hierarchy.characterCreator.selectGenderN.text = self.genderDropdownState.value == 'N' ?
                    "  -  " : self.genderDropdownState.value == 'M' ? "ชาย" : "หญิง"
            }            
        },
        gameLoop(delta) {
            const self = this

            self.iter += 1

            self.hierarchy.shared.tilingSprite.tilePosition.x += TILING_SPEED
            self.hierarchy.shared.tilingSprite.tilePosition.y += TILING_SPEED

            self.hierarchy.title.title.scale.set(
                1 + Math.abs( Math.cos(self.iter * 0.025) * 0.2 )
            ) 
        },
        resize() {
            const self = this

            let w = window.innerWidth
            let h = window.innerHeight

            if (window.innerWidth / window.innerHeight >= self.ratio) {
                w = window.innerHeight * self.ratio
                h = window.innerHeight
            } else {
                w = window.innerWidth
                h = window.innerWidth / self.ratio
            }

            // self.renderer.resize(w, h)

            self.renderer.view.style.width = Util.intPXToCssStr(w)
            self.renderer.view.style.height = Util.intPXToCssStr(h)

            //Center PIXI canvas
            self.renderer.view.style.position = 'absolute'
            self.renderer.view.style.left = ((window.innerWidth - w) * 0.5) + 'px'
        },
    },
    computed: {
        // ...mapGetters({
        //     getITEM: types.GET_ITEM,
        // }),
        // someComputed: function () {
        //     return someValue;
        // },
    },
    components: {    
        // SomeComponent,
    },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Mitr:wght@400;700&display=swap');
</style>